import {createSlice, Dispatch} from '@reduxjs/toolkit';
import {AircraftDefinitionRequest} from 'app/types/service-types/AircraftTypes';
import {AircraftService} from 'app/services';
import {toggleQuickPanel} from 'app/main/shared-components/quick-panel/store';
import {fetchAllAircrafts} from './aircrafts.slice';
import {errorMsg, successMsg} from 'app/utils/MessageUtils';

interface CreateAircraftParams {
  body: AircraftDefinitionRequest;
  onSuccess?: Function;
  onError?: Function;
}

export const createAircraft = (params: CreateAircraftParams) => async (dispatch: Dispatch) => {
  try {
    dispatch(setLoading(true));
    const response = await AircraftService.create(params.body);
    if (response.status === 201) {
      dispatch(setSuccess(true));
      dispatch(toggleQuickPanel());
      dispatch(successMsg('Aircraft created successfully!'));
      if (params.onSuccess) params.onSuccess();
      dispatch(setError(''));
      // @ts-ignore
      dispatch(fetchAllAircrafts());
    }
    dispatch(setLoading(false));
  } catch (err: any) {
    dispatch(setLoading(false));
    dispatch(errorMsg(err?.data?.message));
    if (params.onError) params.onError();
    dispatch(setError(err?.data?.message));
  }
}

interface CreateAircraftSlice {
  success: boolean;
  error: string;
  loading: boolean;
}

const initialState: CreateAircraftSlice = {
  error: '',
  success: false,
  loading: false
}

const stateSlice = createSlice({
  name: 'aircrafts/create-aircraft',
  initialState,
  reducers: {
    setLoading: (state, action) => { state.loading = action.payload },
    setSuccess: (state, action) => { state.success = action.payload },
    setError: (state, action) => { state.error = action.payload }
  }
});

export const {setLoading, setSuccess, setError} = stateSlice.actions;
export default stateSlice.reducer;
